import { inject, Injectable, NgZone } from "@angular/core";
import posthog from "posthog-js";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class PosthogService {
  readonly #ngZone = inject(NgZone);

  constructor() {
    this.initPostHog();
  }

  private initPostHog() {
    if (environment.POSTHOG?.KEY && environment.POSTHOG?.HOST) {
      this.#ngZone.runOutsideAngular(() => {
        posthog.init(environment.POSTHOG.KEY, {
          api_host: environment.POSTHOG.HOST,
          debug: false,
          cross_subdomain_cookie: false,
          capture_pageview: "history_change",
        });
      });
    }
  }
}
